<template><SimpleModuleDashboard :module-id="Modules.GOOGLE_ADWORDS" :profile-id="Profiles.PERSONAL" include-php-custom :actions="actions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default { components: { SimpleModuleDashboard }, data: () => ({ Modules, Profiles, actions: [
  { id: 'configuration', reference: 'configuration', route: 'GoogleAdwordsStaffConfiguration', tone: 'primary' },
  { id: 'crudInformation', reference: 'crudInformation', route: 'GoogleAdwordsStaffCrudInformation', tone: 'primary' },
  { id: 'reports', reference: 'reports', route: 'GoogleAdwordsStaffReports', tone: 'primary' },
] }) }
</script>
